import {
  getEventActionName,
  getSuccessActionName,
} from "../../core/make-action";
import ViewerEvent from "../../core/ViewerEvent";
import { combineReducers } from "redux";
import ViewerMethod from "../../core/ViewerMethod";
import { persistReducer } from "../../core/persistReducer";

function playbackStatus(state = { playing: false, paused: false }, action) {
  switch (action.type) {
    case getEventActionName(ViewerEvent.TTS_STATUS):
      const { playing, paused } = action.eventData;
      return { playing, paused };
    default:
      return state;
  }
}

function rate(state = 0.5, action) {
  switch (action.type) {
    case getSuccessActionName(ViewerMethod.TTS_GET_SETTINGS):
    case getSuccessActionName(ViewerMethod.TTS_SET_RATE):
      return action.resultData.rate;
    default:
      return state;
  }
}

function voiceIndex(state = 0, action) {
  switch (action.type) {
    case getSuccessActionName(ViewerMethod.TTS_GET_SETTINGS):
    case getSuccessActionName(ViewerMethod.TTS_SET_VOICE_INDEX):
      return action.resultData.voiceIndex;
    default:
      return state;
  }
}

function voices(state = [], action) {
  switch (action.type) {
    case getSuccessActionName(ViewerMethod.TTS_GET_VOICES):
      return action.resultData.voices;
    default:
      return state;
  }
}

function altEnabled(state = false, action) {
  switch (action.type) {
    case getSuccessActionName(ViewerMethod.TTS_ENABLE_ALT_TEXT):
    case getSuccessActionName(ViewerMethod.TTS_DISABLE_ALT_TEXT):
      return action.resultData.altEnabled;
    default:
      return state;
  }
}

function voiceName(state = "", action) {
  // Adding voice name to reducer. At first glance this seems pointless without case statements but its used to set up initial state and is changed
  // from the local storage logic below.
  switch (action.type) {
    default:
      return state;
  }
}

const reducer = combineReducers({
  playbackStatus,
  voices,
  voiceIndex,
  altEnabled,
  rate,
  voiceName,
});

export default persistReducer("tts-controls", reducer, {
  stateToStorage: (state) => {
    return {
      altEnabled: state.altEnabled,
      rate: state.rate,
      voiceIndex: state.voiceIndex,
      voiceName: state.voices[state.voiceIndex]?.name,
    };
  },
  storageToState: (store) => {
    return {
      altEnabled: store.altEnabled,
      rate: store.rate,
      voiceIndex: store.voiceIndex,
      voiceName: store.voiceName,
      voices: [],
      playbackStatus: { playing: false, paused: false },
    };
  },
  byBook: false,
});
